
import { ArriveDepartIso } from '../../types'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { addDays } from '~/utility/date/relative'

@Component
export default class LowResultsDates extends Vue {
  @Prop()
    dates: ArriveDepartIso

  modifyDates(days) {
    return {
      dates: this.changeDateRangeByDays(days),
    }
  }

  get correctTranslationKey() {
    if (!this.isFuture(-1)) return 'Low results modify dates by - future'
    return 'Low results modify dates by'
  }

  isFuture(modificator: number): boolean {
    const date = new Date(this.dates.arrive)
    date.setDate(date.getDate() + modificator)
    return date.setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)
  }

  changeDateRangeByDays(days): ArriveDepartIso {
    const dateRange = this.getDateRangeModifiedByDates(days)
    return {
      arrive: dateRange.arrive,
      depart: dateRange.depart,
    }
  }

  private getDateRangeModifiedByDates(days) {
    return {
      arrive: addDays(days, this.dates.arrive),
      depart: addDays(days, this.dates.depart),
    }
  }
}
